export const SelectFilter = ({config, onChange, value}) => (
    <div className="mb-2">
        <select
            className="select select-bordered select-sm w-full bg-base-50 border-base-200 rounded-lg focus:border-primary transition-all font-medium"
            value={value || ""}
            disabled={config.disabled}
            onChange={e => onChange(e.target.value)}
        >
            <option value="">Any {config.label}</option>
            {config.options.map(opt => (
                <option key={opt.value} value={opt.value}>
                    {opt.label}
                </option>
            ))}
        </select>
    </div>
);